//src/components/UI/CloseButton.jsx

import React from "react";

export default function CloseButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Закрыть"
      className="
        absolute top-5 left-5
        flex h-8 w-8 items-center justify-center
        rounded-full
        bg-red-500 text-white
        transition-all duration-200
        hover:scale-110 hover:bg-red-600
        active:scale-95
        shadow-sm
      "
    >
      ✕
    </button>
  );
}
